import { Spinner } from "@/components/ui/spinner";

export function RoutePending() {
  return (
    <div className="grid min-h-screen place-items-center">
      <Spinner className="size-6 text-muted-foreground" />
    </div>
  );
}
